import { apiCall } from "../../../../utils/apiCall";
import { header } from "../../utils/zippyAdminHeader";

export const fetchThemesList = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/themes`
  });
};

export const updateTheme = async (payload: any) => {
  return apiCall({
    method: "PATCH",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/theme`,
    payload: payload
  });
};

export const fetchContentList = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/contents`
  });
};

export const fetchContentDetail = async (id: string) => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/content/${id}`
  });
};

export const fetchSpeakersList = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/content/speakers`
  });
};

export const updateContent = async (payload: any) => {
  return apiCall({
    method: "PATCH",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/content`,
    payload: payload
  });
};

export const fetchFeedbackList = async () => {
  return apiCall({
    method: "GET",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/feedback`
  });
};

export const updateFeedback = async (payload: any) => {
  return apiCall({
    method: "POST",
    header,
    endPoint: `${process.env.REACT_APP_ZIPPY_ADMIN}/daily-checkin/admin/feedback`,
    payload: payload
  });
};